import HubTeamNavItem from './HubTeamNavItem';

export default HubTeamNavItem;
